export default "__VITE_ASSET__fvqJvaYg__"